<template>
  <v-menu
    offset-y
    :close-on-content-click="false"
    :nudge-bottom="2"
    transition="slide-y-transition"
    v-click-outside="onClickOutside"
    @click.native.stop
    v-model="isOpen"
    class="grow"
  >
    <template v-slot:activator="{ on: menu }">
      <v-card
        color="secondarybackground"
        full-width
        min-width="400"
        height="48"
        class="d-flex my-auto pl-2 pr-2"
        style="border: solid 1px red;"
        v-on="menu"
      >
        <v-chip
          v-for="item in selectedEntities"
          :key="item.entity_nav_full_id"
          :color="selectedEntities === entities ? 'primary' : 'lightgrey'"
          class="my-auto mx-1"
          small
          close
          :text-color="selectedEntities === entities ? 'opposite' : ''"
          @update:active="removeSelectedEntities(item)"
        >
          {{ item.id + ' - ' + item.short_name }}
        </v-chip>
      </v-card>
    </template>

    <v-card
      class="mx-auto"
      style="overflow-y: auto;"
      full-width
      max-height="500"
    >
      <v-divider></v-divider>
      <v-text-field
        v-model.lazy="entitiesSearchQuery"
        label="Entité"
        flat
        solo
        :loading="loading"
        hide-details
        clearable
      ></v-text-field>
      <v-divider></v-divider>
      <v-card-text class="ma-0 pa-0">
        <v-treeview
          v-if="!entitiesSearchQuery"
          :items="entitiesItems"
          :load-children="fetchChildEntities"
          transition
          @click.native.stop
          dense
        >
          <template v-slot:label="{ item }">
            <!-- Vuetify checkbox has a little bug when using object in values  -->
            <!-- the solution is to use string value  -->
            <v-checkbox
              :ref="item.id"
              class="ma-0 pa-0"
              dense
              hide-details
              color="primary"
              :value="item"
              v-model="selectedEntities"
              @click.stop
            >
              <template v-slot:prepend>
                <span class="body-2">
                  {{ item.id }} - {{ item.short_name }}
                  {{ item.childcount > 0 ? `(${item.childcount})` : '' }}
                </span>
              </template>
            </v-checkbox>
          </template>
        </v-treeview>
        <v-list v-else dense>
          <p v-if="loading" class="pa-5">Chargement..</p>
          <p v-else-if="!searchEntitiesItems.length" class="pa-5">
            Aucune entité correspondant à la recherche
          </p>
          <v-list-item
            v-else
            dense
            v-for="item in searchEntitiesItems"
            :key="item.title"
            @click="updateSelectedEntitiesFromSearchList(item)"
          >
            <v-list-item-title>
              <span class="body-2">{{ item.id }} - {{ item.name }}</span>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import entitiesAPI from '@/services/api/internal/entitiesAPI';
import createReusableBaseModule from '@/store/reusableBaseModule';
import EntitiesService from '@/services/services/entities.service';

export default {
  name: 'entitiesMenuSelector',
  data() {
    return {
      isOpen: false,
      module: {},
      selectedEntities: [],
      entitiesItems: [],
      entitiesSearchQuery: null,
    };
  },
  created() {
    this.getTopLevelEntities();
    const { names, path } = createReusableBaseModule({
      store: this.$store,
      // eslint-disable-next-line no-underscore-dangle
      name: `${this.$options.name}/${this._uid}`,
      searchAttributesArray: ['id', 'name', 'short_name'],
      serviceAPI: EntitiesService,
    });
    this.module.names = names;
    this.module.path = path;
    this.selectedEntities = this.entities;
  },
  methods: {
    async getTopLevelEntities() {
      const topLevelEntities = await entitiesAPI.getTopLevelEntities();
      topLevelEntities.user_entities.forEach((element) => {
        const el = element;
        if (el.childcount > 0) {
          el.children = [];
        }
        this.entitiesItems.push(el);
      });
    },
    async fetchChildEntities(item) {
      const queryParams = {
        q: { parent_id: { $eq: item.id } },
        limit: 150,
      };
      const childrens = await entitiesAPI.getEntities(queryParams);
      childrens.forEach((element) => {
        const el = element;
        if (el.childcount > 0) {
          el.children = [];
        }
        item.children.push(el);
      });
    },
    removeSelectedEntities(item) {
      const index = this.selectedEntities.findIndex((el) => el === item);
      const newEntities = [...this.selectedEntities];
      newEntities.splice(index, 1);
      this.selectedEntities = newEntities;
      this.isOpen = true;
    },
    updateSelectedEntitiesFromSearchList(entity) {
      const entities = this.selectedEntities
        ? Array.from(this.selectedEntities)
        : [];
      entities.push(entity);

      this.selectedEntities = entities;
      this.entitiesSearchQuery = '';
    },
    updateEntities() {
      const value = this.selectedEntities;
      if (value.length && value !== this.entities) {
        this.$store.dispatch(
          'entities/setCurrent',
          Array.isArray(value) ? value : [value]
        );
      }
    },
    onClickOutside() {
      setTimeout(this.closeOnClick, 50);
    },
    closeOnClick() {
      if (!this.isOpen) {
        this.updateEntities();
      }
    },
  },
  computed: {
    searchEntitiesItems: {
      get() {
        return this.$store.getters[`${this.module.path}/items`].filter(
          (entity) =>
            !this.selectedEntities.some((item) => item.id === entity.id)
        );
      },
    },
    loading: {
      get() {
        return this.$store.getters[`${this.module.path}/isLoadingItems`];
      },
    },
    entities() {
      return this.$store.getters['entities/current'];
    },
  },
  watch: {
    entitiesSearchQuery(val) {
      this.$store.dispatch(`${this.module.path}/search`, val);
    },
    entities(val) {
      if (val) {
        this.selectedEntities = val;
      }
    },
  },
  beforeDestroy() {
    // Unregister the dynamically created module
    this.$store.unregisterModule(this.module.names);
  },
};
</script>
<style scoped></style>
